// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2vn0d","innerTitle":"styles_innerTitle__k5hLQ","description":"styles_description__264gI"};